<template>
  <div>
    <div class="container">
      <div>
        <!-- <gl-switch v-model="allCustomers">全顧客</gl-switch>
        <gl-sub-text>または</gl-sub-text>
        <a class="file-input-link" href="#" @click.prevent="$refs.file.click()"
          >ファイル読込</a
        >
        -->

        <md-radio v-model="_type" value="all" :disabled="disabled"
          >全顧客</md-radio
        >
        <md-radio v-model="_type" value="upload" :disabled="disabled"
          >顧客指定
          <transition>
            <span class="filename" if="file">
              <small> {{ filename }} </small></span
            >
          </transition>
          <gl-sub-text>
            ※
            ファイルアップロードによる顧客指定は「条件を再利用」したときに復元できません。ご自身のPCに大切に保管してください。
          </gl-sub-text>
          <!-- TODO 実質以前の選択顧客を復元することはできないので不要か？ -->
          <gl-sub-text v-if="customerGroupId">
            ※ 顧客の絞込が適用されていました。
          </gl-sub-text>
        </md-radio>
        <input
          type="file"
          ref="file"
          hidden
          @change="setFile($event.target.files)"
        />

        <md-radio v-model="_type" value="attribute" :disabled="disabled"
          >属性指定</md-radio
        >

        <div class="customer-attribute">
          <div class="ages">
            <div class="title">
              <gl-sub-text>年代</gl-sub-text>
            </div>
            <md-checkbox
              v-for="e in ['01', '02', '03', '04', '05', '06', '07', '90']"
              :key="e"
              v-model="_ages"
              :value="e"
              :disabled="!isAttribute || disabled"
            >
              {{ $store.state.labels.ages[e] }}
            </md-checkbox>
          </div>
          <div class="sexes">
            <div class="title">
              <gl-sub-text>性別</gl-sub-text>
            </div>
            <md-checkbox
              v-for="s in sexesModel"
              :key="s.value"
              v-model="_sexes"
              :value="s.value"
              :disabled="!isAttribute || disabled"
            >
              {{ s.text }}
            </md-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 顧客グループ（顧客一覧）選択コンポーネント
 */
export default {
  mixins: [ErrorReport],
  data: function() {
    return {
      sexesModel: [
        { value: '1', text: '男' },
        { value: '2', text: '女' },
        { value: '99', text: 'その他' },
      ],
    }
  },
  props: {
    /**
     * 選択ファイル
     *
     * 実際、分析条件を復元するときにファイルを復元することはできないので、
     * このコンポーネントで選択されたファイルを親コンポーネントに連携する目的で
     * propsにFile型として定義しています。
     */
    file: {
      type: File,
    },
    type: {
      type: String,
    },
    ages: {
      type: Array,
      default: () => [],
    },
    sexes: {
      type: Array,
      default: () => [],
    },
    /**
     * サーバーサイドで保存している一時顧客グループの識別子
     */
    customerGroupId: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAttribute() {
      return this.type === 'attribute'
    },
    /**
     * ローカルの選択
     *
     * MdRadioのv-model用に用意
     */
    _type: {
      get() {
        return this.type
      },
      set(newVal) {
        switch (newVal) {
          case 'all':
          case 'attribute':
            this.$emit('update:file', undefined)
            this.$emit('update:customerGroupId', undefined)
            break
          case 'upload':
            this.$refs.file.click()
        }
        this.$emit('update:type', newVal)
      },
    },
    /**
     * ローカルの年代
     *
     * MdCheckboxのv-model用に用意
     */
    _ages: {
      get() {
        return this.ages
      },
      set(newVal) {
        this.$emit('update:ages', newVal)
      },
    },
    /**
     * ローカルの性別
     *
     * MdCheckboxのv-model用に用意
     */
    _sexes: {
      get() {
        return this.sexes
      },
      set(newVal) {
        this.$emit('update:sexes', newVal)
      },
    },
    filename() {
      if (!this.file) {
        return ''
      }
      return this.file.name
    },
    errors() {
      const errors = []

      if (this.type === 'attribute') {
        if (!this.ages || this.ages.length === 0) {
          errors.push('年代を選択してください')
        }
        if (!this.sexes || this.sexes.length === 0) {
          errors.push('性別を選択してください')
        }
      } else if (this.type === 'upload') {
        if (!this.file) {
          errors.push('顧客ファイルを指定してください')
        }
      }

      return errors
    },
  },
  methods: {
    setFile(files) {
      if (files.length === 0) {
        return
      }
      this.$emit('update:file', files[0])
      this.$emit('update:customerGroupId', undefined)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
}
.md-radio {
  display: flex;
}
.filename {
  font-size: var(--font-size-large);
  margin-left: var(--spacing-medium);
}
.file-attributes {
  font-size: var(--font-size-small);
}
.size {
  margin-left: var(--spacing-small);
}

.file-input-link {
  margin-left: var(--spacing-medium);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s, transform 0.3s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.customer-attribute {
  margin-left: var(--spacing-medium);
}
</style>
